
export default function ServerValidationDirective() {
    return {
        restrict: 'A',
        require: 'form',
        link: function ($scope, el, attrs, $form) {
            $form.$serverErrors = {};
            let watchedFields = [];
            function digFields(errors) {
                _.forOwn(errors, (val, fieldName) => {
                    if (!_.isArray(val) && _.isObject(val)) {
                        digFields(val);
                    } else {
                        val = _.isArray(val) ? val : [val];
                        if ($form[fieldName]) {
                            $form[fieldName].isDirty = true;
                            $form[fieldName].$pristine = false;
                            $form[fieldName].$setValidity('server', false);
                            $form[fieldName].customMessage = Array.prototype.join.call(val, '<br/>')
                            watchOnce(fieldName);
                        }
                    }
                });
            }

            let clearServerError = function (fieldName) {
                if ($form[fieldName]) {
                    $form[fieldName].$setValidity('server', true);
                    // make sure that clearing server side validation does not interfere with client side validation:
                    $form[fieldName].$validate();
                }
                let fieldNameIndex = watchedFields.indexOf(fieldName);
                if (fieldNameIndex > -1) watchedFields.splice(fieldNameIndex, 1);
            };


            let watchOnce = (fieldName) => {
                watchedFields.push(fieldName);
                $form[fieldName].$viewChangeListeners.push(addChangeListener);
                function addChangeListener() {
                    clearServerError(fieldName);
                    let listenerIndex = $form[fieldName].$viewChangeListeners.indexOf(addChangeListener);
                    if (listenerIndex > -1)
                        $form[fieldName].$viewChangeListeners.splice(listenerIndex, 1);
                }
            };

            $scope.$watch('modelState', (errors) => {
                digFields(errors);
            });
        }

    }
}


/** WEBPACK FOOTER **
 ** ./src/directives/servervalidation.directive.js
 **/